export const SET_COURSE_SUBSCRIPTION = "SET_COURSE_SUBSCRIPTION";
export const CREATE_COURSE_SUBSCRIPTION = "CREATE_COURSE_SUBSCRIPTION";
export const UPDATE_COURSE_SUBSCRIPTION = "UPDATE_COURSE_SUBSCRIPTION";
export const UPDATE_CLASS_VACANCY_IN_COURSE_SUBSCRIPTION =
  "UPDATE_CLASS_VACANCY_IN_COURSE_SUBSCRIPTION";
export const CLEAR_COURSE_SUBSCRIPTION = "CLEAR_COURSE_SUBSCRIPTION";
